<div
  [className]="
    getCardClass(statusKey) +
    ' card card-custom m-2 d-flex align-items-center rounded-top pr-1 p-5 pb-10 ' +
    (isPv ? 'cursor-pointer' : ' ')
  "
  (click)="checkUncheckCard()"
  (dblclick)="markError()"
  (mouseleave)="mouseOut()"
>
  <div class="d-flex w-100">
    <div class="d-flex flex-column flex-grow-1" style="width: 80%; max-width: 80%">
      <div
        [class.underline-all-child]="statusKey == 'notPrescribedOrDiscontinued' && card.status == 0"
      >
        <div class="d-flex justify-content-between">
          <div
            (mouseenter)="mouseEnter()"
            class="sig mr-2 cursor-pointer"
            [matTooltip]="card?.rxno"
          >
            Rx : {{ card?.rxno }}
          </div>
          <span
            class="mr-2"
            matTooltip="Type N"
            *ngIf="card.type === 'N'"
            style="display: flex; align-items: center; max-height: 30px; max-width: 30px"
            [inlineSVG]="'./assets/media/svg/icons/Code/special-icon.svg'"
          >
          </span>
        </div>
        <div
          [matTooltip]="
            getDrugDetails(card)
              .replace('<div>', '')
              .replace('<b>', '')
              .replace('</b>', '')
              .replace('</div>', '')
          "
          class="prescription"
          [innerHTML]="getDrugDetails(card) | safe : 'html'"
        ></div>
        <div class="d-flex flex-wrap">
          <div
            *ngIf="!isPv"
            [matTooltip]="getHoa(card, true)"
            class="prescription pr-3"
            [innerHTML]="getHoa(card) | safe : 'html'"
          ></div>
        </div>
        <ng-container *ngIf="isPv || (isMouseHoverRx | async)">
          <div class="d-flex flex-wrap">
            <div matTooltip class="prescription">
              Days Supply: {{ card.prescription ? card.prescription.days_supply : '' }}
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div matTooltip class="prescription">Qty Filled: {{ card.qty_filled }}</div>
          </div>
          <div class="prescription" [matTooltip]="card.drug_written">
            <div>Drug written: {{ card.drug_written }}</div>
          </div>
          <div
            class="prescription"
            *ngIf="!isPv"
            [matTooltip]="card.doctor_first_name + ' ' + card.doctor_last_name"
          >
            <div>Doctor: {{ card.doctor_first_name }} {{ card.doctor_last_name }}</div>
          </div>

          <div class="sig" [matTooltip]="card?.prescription?.sig">
            {{ card?.prescription?.sig }}
          </div>
          <div *ngIf="isPv" class="prescription">
            <div style="display: grid; grid-template-columns: 105px auto 90px auto">
              <div>Qty Written:</div>
              <div>{{ card.qty_written | number }}</div>
              <div>Refills:</div>
              <div>{{ card.refills | number }}</div>
              <div>Qty Filled:</div>
              <div>{{ card.qty_filled | number }}</div>
              <div>Days Supply:</div>
              <div>{{ card.prescription ? card.prescription.days_supply : '' }}</div>
              <div>Prescribe date:</div>
              <div>
                <b>{{ formatDate(card?.prescription?.prescribe_date) }}</b>
              </div>
              <div>Med Type:</div>
              <div>{{ getType(card) }}</div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div *ngIf="!isPv" matTooltip class="prescription">Med Type: {{ getType(card) }}</div>
          </div>
          <div class="d-flex flex-wrap">
            <div *ngIf="!isPv" matTooltip class="prescription">
              Prescribe date: {{ formatDate(card?.prescription?.prescribe_date) }}
            </div>
          </div>
        </ng-container>
      </div>

      <div style="position: absolute; right: 0; bottom: 0; display: flex">
        <i
          *ngIf="card.prescription && card.prescription.note"
          [matTooltip]="card.prescription.note"
          class="pt-1 flaticon2-file-1 text-dark icon-lg"
        ></i>
        <span
          class="ks-m-1"
          matTooltip="PV1"
          [ngClass]="{
            'svg-icon-danger cursor-pointer z-index-1000':
              card.medication_errors && card.medication_errors.length > 0,
            'svg-icon-warning': !(card.medication_error && card.medication_error.length > 0),
            'svg-icon svg-icon-3x': true
          }"
          *ngIf="card.is_verify == '0'"
          style="display: flex; align-items: center; max-height: 30px; max-width: 30px"
          [inlineSVG]="'./assets/media/svg/icons/Code/Warning-2.svg'"
        >
        </span>
        <span
          class="svg-icon svg-icon-3x svg-icon-warning ks-m-1"
          *ngIf="card.hold == '1'"
          [matTooltip]="card.hold_note"
          style="display: flex; align-items: center"
          ><i class="far fa-pause-circle text-grey icon-2x"></i
        ></span>
        <span
          inlineSVG="assets/media/svg/icons/General/prescription-note.svg"
          *ngIf="card.prescription?.has_notes"
          matTooltip="Has prescription notes"
          class="svg-icon svg-icon-lg svg-icon-danger ks-m-1"
          style="display: flex; align-items: center"
        ></span>
        <span
          inlineSVG="assets/media/svg/icons/General/taper.svg"
          *ngIf="card.prescription?.is_taper"
          [matTooltip]="'TAPER:' + card.prescription?.taper_type"
          class="svg-icon svg-icon-lg svg-icon-danger ks-m-1"
          style="display: flex; align-items: center"
        ></span>
      </div>
    </div>
    <div *ngIf="isPv" style="width: 20%; max-width: 20%" class="d-flex">
      <div class="prescription" [innerHTML]="getHoa(card, true) | safe : 'html'"></div>
      <div class="ml-4">DAW: {{ card.daw }}</div>
    </div>
    <div
      style="
        width: 20%;
        max-width: 20%;
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
      "
      [innerHTML]="getBadges(card) | safe : 'html'"
    ></div>
    <div class="d-flex flex-column">
      <div *ngIf="!isPv && !isViewMode && !fromPatient">
        <i class="ki ki-more-ver icon-md cursor-pointer" (click)="mySelect.open()"></i>
        <mat-select class="hide-trigger" #mySelect style="height: 0">
          <mat-option (click)="customDRP()"> Create DRP </mat-option>
          <mat-option (click)="moveToDiscontinued($event, card, statusKey)">
            Move to discontinued
          </mat-option>
          <mat-option (click)="showHistory(card)"> Show History </mat-option>
          <mat-option (click)="showPrescriptionNotes(card)"> Show Prescription Notes </mat-option>
        </mat-select>
      </div>
      <div style="position: absolute; top: 40px">
        <span
          class="svg-icon svg-icon-danger"
          *ngIf="card.showRedBadge"
          inlineSVG="./assets/media/svg/icons/Design/Circle.svg"
          matTooltip="Duplicate Ingredient"
        ></span>
      </div>
    </div>
  </div>
  <div class="card-overlay" *ngIf="!medicationError && (card.disabled || medicationVerified)">
    <div *ngIf="card.disabled">Working...</div>
    <div *ngIf="medicationVerified">Verified</div>
  </div>
  <div class="card-overlay overlay-danger" *ngIf="medicationError">
    <div>Error</div>
  </div>
</div>
